<template>
  <v-autocomplete :loading="loading"
                  :items="items"
                  :item-value="value"
                  :item-text="text"
                  :label="label"
                  :search-input.sync="search"
                  :clearable="clearable"
                  :solo-inverted="soloInverted"
                  :solo="solo"
                  :dense="dense"
                  :flat="flat"
                  :hide-details="hideDetails"
                  :open-on-clear="openOnClear"
                  no-filter
                  v-model="selectItem"
                  hide-no-data
                  :color="color"
                  :hint="hint"
                  :persistent-hint="persistentHint"
                  class="vue-ongeo-autocomplete">
    <template slot="item"
              slot-scope="data">
      <slot v-if="$slots.default"
            name="item"
            :item="data.item"> </slot>
      <v-list-item-content v-else>
        <v-list-item-title v-html="data.item[title]"></v-list-item-title>
        <v-list-item-subtitle v-if="subTitle"
                              v-html="data.item[subTitle]"></v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import axios from "axios";
export default {
  name: "vue-ongeo-autocomplete",
  props: {
    label: { type: String },
    url: { type: String, required: true },
    value: { type: String, default: "title" },
    text: { type: String, default: "title" },
    wrapper: { type: Function },
    title: { type: String, default: "title" },
    subTitle: { type: String },
    color: { type: String, default: "white" },
    clearable: { type: Boolean, default: true },
    dense: { type: Boolean, default: false },
    flat: { type: Boolean, default: false },
    hideDetails: { type: Boolean, default: true },
    solo: { type: Boolean, default: false },
    soloInverted: { type: Boolean, default: true },
    openOnClear: { type: Boolean, default: true },
    hint: { type: String, default: null },
    persistentHint: { type: Boolean, default: false }
  },
  data: () => ({
    loading: false,
    select: null,
    search: null,
    items: []
  }),
  computed: {
    selectItem: {
      set (item) {
        this.select = item;
        this.$emit(
          "selected",
          this.items.filter(x => x[this.value] === item)[0]
        );
      },
      get () {
        return this.select;
      }
    }
  },
  watch: {
    search (val) {
      val && val !== this.select && this.querySelections(val);
    }
  },
  methods: {
    querySelections (v) {
      this.loading = true;
      axios
        .get(this.url + v)
        .then(res => {
          this.items = this.wrapper ? res.data.map(this.wrapper) : res.data;
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },
    remove () {
      this.select = "";
      this.$emit("clear");
    }
  }
};
</script>